import React from 'react'

export const RoutingSankeyEmptyState = () => {
  return (
    <svg
      width="188"
      height="93"
      viewBox="0 0 188 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="17" width="18" height="49" rx="1.75" fill="#BBDBFE" />
      <rect x="95.5" y="1" width="18" height="15" rx="1.75" fill="#BBDBFE" />
      <rect x="173.5" width="14" height="4" rx="1.75" fill="#BBDBFE" />
      <rect x="173.5" y="5" width="14" height="6" rx="1.75" fill="#BBDBFE" />
      <rect x="173.5" y="48" width="14" height="3" rx="1.5" fill="#BBDBFE" />
      <rect
        width="14"
        height="6"
        rx="1.75"
        transform="matrix(1 0 0 -1 173.5 63)"
        fill="#BBDBFE"
      />
      <rect
        width="14"
        height="3"
        rx="1.5"
        transform="matrix(1 0 0 -1 173.5 79)"
        fill="#BBDBFE"
      />
      <rect
        width="14"
        height="6"
        rx="1.75"
        transform="matrix(1 0 0 -1 173.5 86)"
        fill="#BBDBFE"
      />
      <rect
        width="14"
        height="6"
        rx="1.75"
        transform="matrix(1 0 0 -1 173.5 93)"
        fill="#BBDBFE"
      />
      <rect x="95.5" y="29" width="18" height="16" rx="1.75" fill="#BBDBFE" />
      <rect x="95.5" y="56" width="18" height="28" rx="1.75" fill="#BBDBFE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5218 16.9958C20.9695 17.0004 20.5 17.4477 20.5 18V30C20.5 30.5523 20.9696 31.0004 21.5218 30.9959C56.6658 30.7121 57.3342 15.7879 92.4782 15.5041C93.0304 15.4996 93.5 15.0523 93.5 14.5V2C93.5 1.44772 93.0305 0.999629 92.4782 1.00423C57.3342 1.2972 56.6658 16.7028 21.5218 16.9958Z"
        fill="#DCECFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5219 34.9985C20.9696 35.0001 20.5 35.4477 20.5 36V48C20.5 48.5523 20.9696 49.0001 21.5219 48.9989C56.6658 48.9257 57.3342 45.0743 92.4781 45.0011C93.0304 44.9999 93.5 44.5523 93.5 44V30.5C93.5 29.9477 93.0304 29.4999 92.4781 29.5015C57.3342 29.6022 56.6658 34.8978 21.5219 34.9985Z"
        fill="#DCECFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5219 53.0009C20.9696 52.9999 20.5 53.4477 20.5 54V66C20.5 66.5523 20.9695 66.9996 21.5218 67.0042C56.6658 67.2972 57.3342 82.7028 92.4782 82.9958C93.0305 83.0004 93.5 82.5523 93.5 82V57.5C93.5 56.9477 93.0304 56.5001 92.4781 56.4991C57.3342 56.435 56.6658 53.065 21.5219 53.0009Z"
        fill="#DCECFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.519 1.09042C115.967 1.09095 115.5 1.53863 115.5 2.09091V5C115.5 5.55229 115.967 6.00007 116.519 5.99927C143.169 5.96054 143.831 4.40309 170.481 4.36437C171.033 4.36357 171.5 3.91592 171.5 3.36364V1C171.5 0.447715 171.033 -4.54591e-05 170.481 0.000489523C143.831 0.0263043 143.169 1.0646 116.519 1.09042Z"
        fill="#DCECFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.519 6.9991C115.967 7.00008 115.5 7.44772 115.5 8V15C115.5 15.5523 115.967 16.0002 116.519 15.9978C143.169 15.8794 143.831 11.1206 170.481 11.0022C171.033 10.9998 171.5 10.5523 171.5 10V6C171.5 5.44772 171.033 4.99992 170.481 5.0009C143.831 5.04822 143.169 6.95178 116.519 6.9991Z"
        fill="#DCECFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.519 29.0085C115.967 28.9992 115.5 29.4477 115.5 30V33C115.5 33.5523 115.967 33.9993 116.519 34.0076C143.169 34.4098 143.831 50.5902 170.481 50.9924C171.033 51.0007 171.5 50.5523 171.5 50V49C171.5 48.4477 171.033 48.0008 170.481 47.9915C143.831 47.542 143.169 29.458 116.519 29.0085Z"
        fill="#DCECFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.519 35.0099C115.967 34.9991 115.5 35.4477 115.5 36V44.0001C115.5 44.5523 115.967 44.9993 116.519 45.0081C143.169 45.434 143.831 62.5661 170.481 62.9919C171.033 63.0008 171.5 62.5523 171.5 62V58C171.5 57.4477 171.033 57.0009 170.481 56.9901C143.831 56.4697 143.169 35.5303 116.519 35.0099Z"
        fill="#DCECFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.519 57.0085C115.967 56.9992 115.5 57.4477 115.5 58V61C115.5 61.5523 115.967 61.9993 116.519 62.0076C143.169 62.4098 143.831 78.5902 170.481 78.9924C171.033 79.0007 171.5 78.5523 171.5 78V77C171.5 76.4477 171.033 76.0008 170.481 75.9915C143.831 75.542 143.169 57.458 116.519 57.0085Z"
        fill="#DCECFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.519 63.0076C115.967 62.9993 115.5 63.4477 115.5 64V72C115.5 72.5523 115.967 72.9995 116.519 73.0058C143.169 73.3134 143.831 85.6866 170.481 85.9942C171.033 86.0005 171.5 85.5523 171.5 85V81C171.5 80.4477 171.033 80.0007 170.481 79.9924C143.831 79.5902 143.169 63.4098 116.519 63.0076Z"
        fill="#DCECFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.519 74.0058C115.967 73.9995 115.5 74.4477 115.5 75V83C115.5 83.5523 115.967 83.9996 116.519 84.004C143.169 84.217 143.831 92.783 170.481 92.996C171.033 93.0004 171.5 92.5523 171.5 92V88C171.5 87.4477 171.033 87.0005 170.481 86.9942C143.831 86.6866 143.169 74.3134 116.519 74.0058Z"
        fill="#DCECFE"
      />
    </svg>
  )
}
